<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <!-- Not expandable nodes -->
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
    <!-- use a disabled button to provide padding for tree leaf -->
    <button mat-icon-button disabled></button>
    <div *ngIf="!_detailMode" [formGroup]="treeForm">
        <mat-checkbox class="leaf-node" [formControlName]="node.level + '-' + node.id"> 
            {{ getItemName(node)}}
        </mat-checkbox>  
    </div>
    <div *ngIf="_detailMode" [formGroup]="treeForm">
        <div class="readonly-leaf"> 
          <mat-icon *ngIf="!!treeForm.get(node.level + '-' + node.id).value" class="m-8">check_box</mat-icon>
          <mat-icon *ngIf="!treeForm.get(node.level + '-' + node.id).value" class="m-8">check_box_outline_blank</mat-icon>
          <span style="font-weight: bold;">{{ getItemName(node) }}</span>
        </div>                                   
    </div>    
  </mat-tree-node>

  <!-- expandable nodes -->
  <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
    <button mat-icon-button matTreeNodeToggle
            [attr.aria-label]="'toggle ' + node.name">
      <mat-icon class="mat-icon-rtl-mirror">
        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
      </mat-icon>
    </button>
    {{ getItemName(node)}}
  </mat-tree-node>
</mat-tree>